<template>
  <div>
    <spinner-component :loading="loading"></spinner-component>
    <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
    <v-container>
      <v-row>
        <v-col>
          <router-link :to="{ name: 'popup-new' }">
            <v-btn block
                   color="primary"
                   elevation="2"
                   large
            >
              Dodaj nowy popup
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="popupContents"
      >
        <template v-slot:[`item.published`]="{ item }">
          <v-chip
              :color="item.published === true ? 'green' : 'orange'"
              text-color="white"
          >
            {{ item.published === true ? 'Opublikowany' : 'Draft' }}
          </v-chip>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.updatedAt`]="{ item }">
          {{ formatDate(item.updatedAt) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                Akcje
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <router-link :to="{ name: 'popup-edit', params: { id: item.id } }">
                    <v-btn>Edytuj</v-btn>
                  </router-link>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-btn
                      @click="deactivatePopup(item.id)"
                  >Deaktywuj
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-btn
                      @click="deletePopupContent(item.id)"
                  >Usuń
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>

import SpinnerComponent from "@/components/SpinnerComponent";
import ErrorDialogComponent from "@/components/ErrorDialogComponent";
import {popupApiClient} from "@/api/popup.api.client";

export default {
  name: 'PopupContentsView',

  components: {
    SpinnerComponent,
    ErrorDialogComponent
  },

  data() {
    return {
      popupContents: [],
      headers: [
        {
          text: 'Nazwa',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Opublikowano',
          align: 'start',
          sortable: true,
          value: 'published',
        },
        {
          text: 'Utworzono',
          align: 'start',
          sortable: true,
          value: 'createdAt',
        },
        {
          text: 'Zaktualizowano',
          align: 'start',
          sortable: true,
          value: 'updatedAt',
        },
        {
          text: 'Akcje',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ],

      // MISC
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false
      }
    }
  },

  created() {
    this.getPopupContents();
  },

  methods: {
    getPopupContents() {
      this.loading = true;
      popupApiClient.getPopupContents(
          (response) => {
            this.popupContents = response.data;
          },
          () => {
            this.errorDialog.visible = true;
            this.errorDialog.errorMessage = "Błąd pobierania popupów!";
          },
          () => this.loading = false
      );
    },

    deactivatePopup(id) {
      if (confirm('Czy na pewno chcesz deaktywować ten popup?')) {
        popupApiClient.deactivatePopup(
            id,
            () => {
              this.getPopupContents();
            },
            () => {
              this.errorDialog.visible = true;
              this.errorDialog.errorMessage = "Błąd podczas usuwania popupu!";
            }
        );
      }
    },

    deletePopupContent(id) {
      if (confirm('Czy na pewno chcesz usunąć ten popup?')) {
        popupApiClient.deletePopupContent(
            id,
            () => {
              this.getPopupContents();
            },
            () => {
              this.errorDialog.visible = true;
              this.errorDialog.errorMessage = "Błąd podczas usuwania popupu!";
            }
        );
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString('pl-PL');
    }
  }
}
</script>

<style scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style> 